if (!customElements.get('custom-media-gallery')) {
  customElements.define(
    'custom-media-gallery',
    class CustomMediaGallery extends HTMLElement {
      constructor() {
        super();

        this.mainImage = this.querySelector('.custom-product-media-gallery__main img');
        this.thumbnailImages = this.querySelectorAll('.custom-product-media-gallery__thumbnails-container img');

        this.thumbnailImages.forEach((thumbnail) => {
          thumbnail.addEventListener('click', this.handleMainImageChange.bind(this, thumbnail));
        });
        this.variantSelectorButtons = document.querySelectorAll('');
      }
      handleMainImageChange(thumbnail) {
        this.mainImage.src = thumbnail.src;
        this.thumbnailImages.forEach((thumbnail) => {
          thumbnail.classList.remove('custom-product-media-gallery__thumbnail--active');
        });
        thumbnail.classList.add('custom-product-media-gallery__thumbnail--active');
      }
      handleVariantChange(newVariantImageDataId) {
        const newMainImage = this.querySelector(`img[data-media-id="${newVariantImageDataId}"]`);
        this.handleMainImageChange(newMainImage);
      }
    }
  );
}
